<template>
  <v-progress-circular
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: "EkitabuProgressCircular",
  inheritAttrs: false,
};
</script>
